var map = {
	"./R0.png": 109,
	"./R10.png": 181,
	"./R100.gif": 294,
	"./R100.png": 182,
	"./R20.png": 183,
	"./R30.png": 184,
	"./R40.png": 185,
	"./R50.png": 186,
	"./R60.png": 187,
	"./R70.png": 188,
	"./R80.png": 189,
	"./R90.png": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;